import { getUrgentUnshippedOrders } from './shipByUrgency';

function UrgencyMessage({ alert }) {
  if (alert.type === 'overdue') {
    return (
      <>
        <strong className="font-semibold">{alert.label}</strong> is overdue — ship this product
        immediately (order {alert.amazonOrderId}).
      </>
    );
  }

  return (
    <>
      <strong className="font-semibold">{alert.label}</strong> has{' '}
      {alert.hoursLeft === 1 ? '1hr' : `${alert.hoursLeft}hr`} left to ship this product (order{' '}
      {alert.amazonOrderId}).
    </>
  );
}

export function ShipByUrgencyAlert({ orders, now = Date.now() }) {
  const alerts = getUrgentUnshippedOrders(orders, now);

  if (!alerts.length) {
    return null;
  }

  const hasOverdue = alerts.some((alert) => alert.type === 'overdue');

  return (
    <div
      className={[
        'rounded-xl border-2 px-4 py-4 shadow-sm',
        hasOverdue
          ? 'border-red-400 bg-red-50 text-red-950'
          : 'border-red-300 bg-red-50 text-red-900',
      ].join(' ')}
      role="alert"
      aria-live="assertive"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold uppercase tracking-wide text-red-700">
            {hasOverdue ? 'Ship immediately — deadline passed' : '24 hours left to ship'}
          </p>
          <ul className="mt-2 grid gap-2 text-sm leading-relaxed">
            {alerts.map((alert) => (
              <li key={`${alert.orderId}-${alert.amazonOrderId}`}>
                <UrgencyMessage alert={alert} />
              </li>
            ))}
          </ul>
        </div>
        <span className="inline-flex shrink-0 items-center rounded-full bg-red-600 px-3 py-1 text-xs font-bold text-white">
          {alerts.length} urgent
        </span>
      </div>
    </div>
  );
}
